(function attachJudesTrialBundleRecipes(root) {
  'use strict';

  const covers = {
    s1: [
      '40504362172605', '54807944724748', '54807936336140', '39662967816381',
      '40504337662141', '40504364826813', '41462371582141', '41462371647677',
      '41462371713213', '43799729111308', '43799767515404', '43799772791052',
      '49243444052236', '49243456340236', '49243467448588', '49243473543436',
      '54108793766156', '54108814377228', '54108815589644', '54108816310540',
      '54440696054028', '54440700477708', '54440701427980', '54440702574860',
      '54807933387020', '54807932961036'
    ],
    s2: [
      '40504363352253', '54807944757516', '54807936368908', '40460580716733',
      '40504340873405', '40504366039229', '41462371614909', '41462371680445',
      '41462371745981', '43799743693068', '43799768105228', '43799773184268',
      '49243453915404', '49243457323276', '49243469414668', '49243474755852',
      '54108793798924', '54108814409996', '54108815622412', '54108816343308',
      '54440699363596', '54440700936460', '54440702017804', '54440702935308',
      '54807933419788', '54807932993804'
    ]
  };

  function coverDesignGroup(id, label, variantIds, limit) {
    const group = { id, label, variantIds: Object.freeze(variantIds) };
    if (limit) group.limit = limit;
    return Object.freeze(group);
  }

  // Cover picker collections: display order and the order for replacing an unavailable design. Allowed
  // variants, defaults and pricing stay above. Labels stay English in every locale. Most Popular is the Probier
  // ranking; the Builder shows its first `limit` designs that are available in the buyer's market. The five
  // collections list every cover exactly once. Names follow the Shopify variant titles.
  const coverDesignGroups = {
    s1: Object.freeze([
      coverDesignGroup('most-popular', 'Most Popular', [
        '40504362172605', // Sage
        '40504364826813', // Chickpea
        '41462371582141', // Sunny Dots
        '54440696054028', // Buttercream
        '43799729111308', // Kale
        '49243444052236', // Rose
        '54807944724748', // Lilac
        '39662967816381', // Aubergine
        '49243456340236', // Sea
        '43799767515404', // Beetroot
        '54807936336140', // Matcha
        '49243467448588', // Sand
        '41462371713213', // Dark Dots
        '40504337662141', // Spinach
        '54440702574860', // Mocha
        '54440701427980', // Blueberry
        '49243473543436', // Kale Dots
        '41462371647677', // Cloudy Dots
        '54440700477708', // Coral
        '43799772791052', // Plum
        '54108793766156', // Bright Flow
        '54108815589644', // Cool Flow
        '54108814377228', // Soft Flow
        '54108816310540', // Warm Flow
        '54807933387020', // Daisy
        '54807932961036' // Dandelion
      ], 6),
      coverDesignGroup('soft-pastels', 'Soft Pastels', [
        '40504362172605', // Sage
        '54440696054028', // Buttercream
        '49243444052236', // Rose
        '49243467448588', // Sand
        '40504337662141', // Spinach
        '41462371647677' // Cloudy Dots
      ]),
      coverDesignGroup('rich-earthy', 'Rich & Earthy', [
        '40504364826813', // Chickpea
        '43799729111308', // Kale
        '39662967816381', // Aubergine
        '43799767515404', // Beetroot
        '54440702574860', // Mocha
        '43799772791052' // Plum
      ]),
      coverDesignGroup('prints-bold', 'Prints & Bold', [
        '41462371582141', // Sunny Dots
        '49243456340236', // Sea
        '41462371713213', // Dark Dots
        '54440701427980', // Blueberry
        '49243473543436', // Kale Dots
        '54440700477708' // Coral
      ]),
      coverDesignGroup('fleur-limited', 'Fleur Limited Edition', [
        '54807933387020', // Daisy
        '54807932961036', // Dandelion
        '54807944724748', // Lilac
        '54807936336140' // Matcha
      ]),
      coverDesignGroup('flow-limited', 'Flow Limited Edition', [
        '54108814377228', // Soft Flow
        '54108793766156', // Bright Flow
        '54108815589644', // Cool Flow
        '54108816310540' // Warm Flow
      ])
    ]),
    s2: Object.freeze([
      coverDesignGroup('most-popular', 'Most Popular', [
        '40504363352253', // Sage
        '40504366039229', // Chickpea
        '41462371614909', // Sunny Dots
        '54440699363596', // Buttercream
        '43799743693068', // Kale
        '49243453915404', // Rose
        '54807944757516', // Lilac
        '40460580716733', // Aubergine
        '49243457323276', // Sea
        '43799768105228', // Beetroot
        '54807936368908', // Matcha
        '49243469414668', // Sand
        '41462371745981', // Dark Dots
        '40504340873405', // Spinach
        '54440702935308', // Mocha
        '54440702017804', // Blueberry
        '49243474755852', // Kale Dots
        '41462371680445', // Cloudy Dots
        '54440700936460', // Coral
        '43799773184268', // Plum
        '54108793798924', // Bright Flow
        '54108815622412', // Cool Flow
        '54108814409996', // Soft Flow
        '54108816343308', // Warm Flow
        '54807933419788', // Daisy
        '54807932993804' // Dandelion
      ], 6),
      coverDesignGroup('soft-pastels', 'Soft Pastels', [
        '40504363352253', // Sage
        '54440699363596', // Buttercream
        '49243453915404', // Rose
        '49243469414668', // Sand
        '40504340873405', // Spinach
        '41462371680445' // Cloudy Dots
      ]),
      coverDesignGroup('rich-earthy', 'Rich & Earthy', [
        '40504366039229', // Chickpea
        '43799743693068', // Kale
        '40460580716733', // Aubergine
        '43799768105228', // Beetroot
        '54440702935308', // Mocha
        '43799773184268' // Plum
      ]),
      coverDesignGroup('prints-bold', 'Prints & Bold', [
        '41462371614909', // Sunny Dots
        '49243457323276', // Sea
        '41462371745981', // Dark Dots
        '54440702017804', // Blueberry
        '49243474755852', // Kale Dots
        '54440700936460' // Coral
      ]),
      coverDesignGroup('fleur-limited', 'Fleur Limited Edition', [
        '54807933419788', // Daisy
        '54807932993804', // Dandelion
        '54807944757516', // Lilac
        '54807936368908' // Matcha
      ]),
      coverDesignGroup('flow-limited', 'Flow Limited Edition', [
        '54108814409996', // Soft Flow
        '54108793798924', // Bright Flow
        '54108815622412', // Cool Flow
        '54108816343308' // Warm Flow
      ])
    ])
  };

  const wetbags = [
    '54276133847308', '54276133880076', '54276133912844', '54276133945612',
    '54782484807948', '54782485594380', '54782475075852', '54782500569356',
    '54807969759500', '54807971397900'
  ];
  const mats = ['54653996826892', '54653996859660', '54653996892428', '54653996925196'];

  const parents = {
    s1: { once: '54149634588940', day: '44565594702092' },
    s2: { once: '54149634621708', day: '44565594767628' }
  };

  const discounts = {
    s1: {
      once: { amountMinor: 355, code: 'bb_tso1_54149634588940' },
      day: { amountMinor: 4630, code: 'bb_tshd1_44565594702092' }
    },
    s2: {
      once: { amountMinor: 355, code: 'bb_tso2_54149634621708' },
      day: { amountMinor: 4630, code: 'bb_tshd2_44565594767628' }
    }
  };

  function fixedItem(variantId, quantity, label, includedOrder) {
    return { variantId, quantity, giftQuantity: 0, label, includedLabel: label, includedOrder };
  }

  function choiceGroup(id, label, quantity, allowedVariantIds, defaultVariantIds, designGroups) {
    const group = {
      id,
      label,
      includedLabel: label,
      quantity,
      giftQuantity: 0,
      allowedVariantIds,
      defaultVariantIds
    };
    if (designGroups) group.designGroups = designGroups;
    return group;
  }

  function makeRecipe(sizeKey, trialKey) {
    const sizeOne = sizeKey === 's1';
    const fullDay = trialKey === 'day';
    const sizeLabel = sizeOne ? 'Size 1 (3–8 kg)' : 'Size 2 (7–16 kg)';
    const discount = discounts[sizeKey][trialKey];
    const fixedItems = [
      fixedItem(sizeOne ? '40504412700861' : '40460286296253', fullDay ? 3 : 1, 'Inner diapers', 1),
      fixedItem(sizeOne ? '43560222884108' : '43560222916876', 1, 'Poo Paper samples', 2)
    ];

    if (fullDay) fixedItems.push(fixedItem('44105181888780', 1, 'Booster insert', 3));

    const choiceGroups = [
      choiceGroup('covers', 'Diaper cover', 1, covers[sizeKey], [covers[sizeKey][0]], coverDesignGroups[sizeKey])
    ];

    if (fullDay) {
      choiceGroups.push(choiceGroup('small-wetbags', 'Small diaper bag', 1, wetbags, [wetbags[0]]));
      choiceGroups.push(choiceGroup('changing-mats', 'Changing mat', 1, mats, [mats[0]]));
    }

    return Object.freeze({
      id: `trial-${trialKey}-${sizeKey}`,
      bundleType: 'trial',
      parentVariantId: parents[sizeKey][trialKey],
      pricingMode: 'standard_discount',
      standardDiscountAmountMinor: discount.amountMinor,
      discountCodes: { standardDiscount: discount.code, giftDiscount: '' },
      trialKey,
      routineKey: trialKey,
      freeIncludedGroupId: fullDay ? 'changing-mats' : '',
      sizeKey,
      productHeading: 'Trial Set',
      routineLabel: fullDay ? 'Full-Day' : 'Once',
      sizeLabel,
      description: fullDay
        ? 'A realistic full-day trial with everything you need away from home.'
        : 'The smallest, easiest way to try one complete diaper change.',
      perks: fullDay
        ? ['Try a realistic full day with Judes', 'Includes practical extras for changing away from home']
        : ['Try one complete diaper change', 'Start with the smallest budget'],
      metrics: fullDay
        ? { share: '1 day', plastic: '75 kg', savings: '€188', shareSegments: 4, plasticSegments: 4, savingsSegments: 4 }
        : { share: '1×', plastic: '25 kg', savings: '€63', shareSegments: 1, plasticSegments: 1, savingsSegments: 1 },
      fixedItems,
      choiceGroups,
      presets: []
    });
  }

  const recipes = ['s1', 's2'].flatMap((sizeKey) => (
    ['once', 'day'].map((trialKey) => makeRecipe(sizeKey, trialKey))
  ));

  root.JudesTrialBundleRecipes = Object.freeze({
    version: 1,
    sourceVersion: 'probier-default-recipes-1',
    pricingMode: 'standard_discount',
    recipes: Object.freeze(recipes)
  });
}(typeof globalThis !== 'undefined' ? globalThis : this));
